import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import * as FiIcons from 'react-icons/fi'
import SafeIcon from '../ui/SafeIcon'

function CategoriesSection() {
  const { t } = useTranslation()

  const categories = [
    { id: 'electronics', icon: '📱', count: '2.5M+', color: 'bg-blue-100 text-blue-600' },
    { id: 'fashion', icon: '👕', count: '1.8M+', color: 'bg-pink-100 text-pink-600' },
    { id: 'home', icon: '🏠', count: '1.2M+', color: 'bg-green-100 text-green-600' },
    { id: 'beauty', icon: '💄', count: '950K+', color: 'bg-purple-100 text-purple-600' },
    { id: 'toys', icon: '🧸', count: '800K+', color: 'bg-yellow-100 text-yellow-600' },
    { id: 'sports', icon: '⚽', count: '650K+', color: 'bg-orange-100 text-orange-600' },
    { id: 'machinery', icon: '⚙️', count: '500K+', color: 'bg-gray-100 text-gray-600' },
    { id: 'packaging', icon: '📦', count: '400K+', color: 'bg-indigo-100 text-indigo-600' }
  ]

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            {t('categories.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t('categories.subtitle')}
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {categories.map((category, index) => (
            <motion.div
              key={category.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <Link
                to={`/search?category=${category.id}`}
                className="block p-6 bg-gray-50 rounded-xl hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group h-full"
              >
                <div className="text-center">
                  {/* Icon */}
                  <div className="text-4xl mb-3 group-hover:scale-110 transition-transform">
                    {category.icon}
                  </div>
                  {/* Name */}
                  <h3 className="font-semibold text-gray-900 mb-2 group-hover:text-[#FF6600] transition-colors">
                    {t(`category.${category.id}`)}
                  </h3>
                  {/* Count */}
                  <p className="text-sm text-gray-500">{category.count}</p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center mt-12">
          <Link
            to="/search"
            className="inline-flex items-center px-6 py-3 border border-[#FF6600] text-[#FF6600] rounded-lg font-medium hover:bg-[#FF6600] hover:text-white transition-colors"
          >
            {t('categories.viewAll')}
            <SafeIcon icon={FiIcons.FiArrowRight} className="ml-2 w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  )
}

export default CategoriesSection